

import {IPayroll} from 'features/production/models/Payroll';

export interface IPayrollProcessing {
    id: number,

    type: 'month' | 'week' | 'day' | 'year';
    
    date: Date,

    startDate: Date,
    endDate: Date,
    issueDate: Date,
    year: number,
    isCancelled: boolean,
    cancellationDate: Date,
    cancellationPurpose: string,
        
    month: number,
    week: number,
    day: number,

    payrolls: IPayroll[]
  }


  export const defaultPayrollProcessing : IPayrollProcessing = {
    id: 0,

    type: 'month',
    date: new Date(),

    startDate: new Date(),
    endDate: new Date(),
    issueDate: new Date(),
    year: 0,
    isCancelled: false,
    cancellationDate: new Date(),
    cancellationPurpose: '',
        
    month: 0,
    week: 0,
    day: 0,

    payrolls: []
  }


  export interface IPayrollProcessingSearch {
    
    type: string,

    dateFrom: Date,
    dateTo: Date,
  }